<template>
  <proa-card flat class="invalid-token-card">
    <div class="content-wrapper">
      <router-link :to="{ name: 'root' }" class="logo">
        <img :src="require('@/assets/images/logo.png')"/>
      </router-link>
      <span class="welcome-message">{{ $t('common.welcomeToSharewind') }}</span>
      <div class="invite-to">
        <span>{{ $t('pages.inviteUser.requiredSignOutCard.thisInvitationIs') }}</span>
        <span class="font-weight-w6">{{ email }}</span>
        <span>{{ $t('pages.inviteUser.requiredSignOutCard.hasBeenSentTo') }}</span>
      </div>
      <div class="required-sign-out">{{ requiredActionText }}</div>
      <div>
        <proa-button
          class="w-100"
          type="submit"
          variant="primary"
          @click.native="$emit(requiredAction === 'signIn' ? 'onClickSignIn' : 'onClickSignOut')"
        >
          {{ requiredAction === 'signIn' ? $t('common.signIn') : $t('common.signOut') }}
        </proa-button>
      </div>
    </div>
  </proa-card>
</template>

<script>
import i18n from '@/i18n'

export default {
  name: 'RequiredSignInOrOutCard',
  props: {
    email: String,
    requiredAction: String
  },
  computed: {
    requiredActionText: function() {
      let tc = ''
      switch (this.requiredAction) {
        case 'signIn': {
          tc = i18n.tc('pages.inviteUser.requiredSignOutCard.pleaseSignIn')
          break
        }
        case 'signOut': {
          tc = i18n.tc('pages.inviteUser.requiredSignOutCard.pleaseSignOut')
          break
        }
        case 'signOutAndSignInAgain': {
          tc = i18n.tc('pages.inviteUser.requiredSignOutCard.pleaseSignOutAndSignInAgain')
          break
        }
      }
      return tc
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.invalid-token-card {
  width: 100%;

  @include mq(sm) {
    width: 400px;
  }
}

.content-wrapper {
  padding: 40px 50px;
  text-align: center;

  .logo {
    display: block;
    margin-bottom: 40px;

    img {
      width: 150px;
    }
  }

  .welcome-message {
    color: $primary-color;
    font-weight: 600;
  }

  .invite-to {
    margin: 40px 0;

    span {
      display: block;
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .required-sign-out {
    margin-bottom: 40px;
    white-space: pre-wrap;
  }
}
</style>
